import React from 'react'

import dfpContentLoader from 'sen/components/lib/useDFPContentCondition/DFPContentLoader'
import DomainFraudContent from 'sen/components/pages/domainFraud/content/DomainFraudContent'

export default dfpContentLoader({
  default: () => <DomainFraudContent />
})
